import { useMemo } from 'react';

export const useNavConfig = () => {
  // External navigation links removed for Curiescious
  return useMemo(() => [], []);
};
